import * as angular from "angular";
import {IController} from "angular";
import {PlanningViewSettingsJobsModel} from "../../../models/planning-view-settings.model";

export class PlanningDraftJobsSettingsPanelTemplateComponent implements IController {

  settings: PlanningViewSettingsJobsModel;
  panelRef: any;

  public settingsCopy: PlanningViewSettingsJobsModel;
  public enabledSections: {
    columns: boolean;
    load: boolean;
    general: boolean;
  } = {
    columns: true,
    load: true,
    general: true
  };

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey] = isEnabled;
  }

  onChangeLoad(loadKey, isEnabled) {
    this.settingsCopy.load[loadKey] = isEnabled;
  }

  onChangeGeneral(loadKey, isEnabled) {
    this.settingsCopy.general[loadKey] = isEnabled;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.agents')
  .component('planningDraftJobsSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      panelRef: '<'
    },
    template: require('./planning-draft-jobs-settings-panel-template.html').default,
    controller: PlanningDraftJobsSettingsPanelTemplateComponent
  });
